export class ArticleBehaviorPropertyDef {
  public static readonly DRAW_SEPARATION_LINES: string = 'drawSeparationLines';
  public static readonly DYNAMIC_LENGTH: string = 'dynamicLength';
  public static readonly MAX_LENGTH: string = 'maxLength';
  public static readonly UNIT_COUNT: string = 'unitCount';
  public static readonly MULTIPLY_RANGE: string = 'multiplyRange';
  public static readonly AVAILABLE_IN_PRODUCTION_COUNTRY: string = 'availableInProductionCountry';

  public static readonly SHAPE_TYPE: string = 'shapeType';
  public static readonly SIZE_ON_LINE: string = 'sizeOnLine';
  public static readonly SIZE_LABEL: string = 'sizeLabel';

  public static readonly VERSION_OVERWRITE_MODE: string = 'versionOverwriteMode';
  public static readonly NOT_SEARCHABLE: string = 'notSearchable';
  public static readonly IS_NOT_DELETABLE: string = 'isNotDeletable';
  public static readonly IS_NOT_REPLACEABLE: string = 'isNotReplaceable';
  public static readonly IS_NOT_LISTED_IN_REPORTS: string = 'isNotListedInReports';
  public static readonly IS_ARTICLE_NUMBER_HIDDEN: string = 'isArticleNumberHidden';
  public static readonly IS_INTERNAL: string = 'isInternal';

  public static readonly COMPOSITE_ARTICLE_TYPE: string = 'compositeArticleType';
  public static readonly COMPOSITE_BASEARTICLE_TYPE_ID: string = 'compositeBaseArticleTypeId';
  public static readonly IS_COMPOSITE_PART_SELECTION_ALLOWED: string = 'isCompositePartSelectionAllowed';
  public static readonly IS_COMPOSITE_PART_MODIFICATION_ALLOWED: string = 'isCompositePartModificationAllowed';
  public static readonly IS_COMPOSITE_ARTICLE_STICK_TOGETHER: string = 'isCompositeArticleStickTogether';

  public static readonly ARTICLE_WIDTH: string = 'articleWidth';

  public static readonly IS_SELF_CONNECTING_BRIDGES_ALLOWED: string = 'isSelfConnectingBridgesAllowed';
  public static readonly IS_STAGGERED_JUMPER: string = 'isStaggeredJumper';

  public static readonly IS_EXCLUDED_FROM_PRINT_LABELING: string = 'isExcludedFromPrintLabeling';

  public static readonly DIMENSION_ID: string = 'drillDimensionID';

  public static readonly MOUNTING_RAIL_TYPE: string = 'mountingRailType';

  public static readonly LABELING_CATEGORY: string = 'labelingCategory';

  public static readonly IS_COVER_LABEL_STRIP: string = 'isCoverLabelStrip';
  public static readonly IS_MARKER_CARRIER_WITH_SEPARATE_LABELING: string = 'isMarkerCarrierWithSeparateLabeling';

  public static readonly IS_INITIAL_ROTATION_IN_MCS_GDS_REQUIRED: string = 'isInitialRotationInMcsGdsRequired';
  public static readonly IS_BUSBAR_WITHOUT_DIMENSION: string = 'isBusbarWithoutDimension';

  public static readonly OVERLAP_TYPE: string = 'overlapType';
  public static readonly OVERLAP_RIGHT: string = 'overlapRight';
  public static readonly OVERLAP_LEFT: string = 'overlapLeft';
  public static readonly IS_LABELING_ACROSS_OVERLAP_ALLOWED: string = 'isLabelingAcrossOverlapAllowed';

  public static readonly ALTERNATIVE_WITHOUT_CODINGFINGER: string = 'alternativeWithoutCodingFinger';
  public static readonly ALTERNATIVE_WITH_CODINGFINGER: string = 'alternativeWithCodingFinger';

  public static readonly IS_CONTINUOUS_JUMPER: string = 'isContinuousJumper';

  public static readonly HAS_CUTMARK_ABILITY: string = 'hasCutmarkAbility';
  public static readonly CONTOUR_THRESHOLD_ANGLE: string = 'contourThresholdAngle';

  public static readonly MOUNTING_RAIL_MATERIAL: string = 'mountingRailMaterial';
}
